import { GlassWater, Leaf, Newspaper, Package, Recycle, Zap, type LucideIcon } from 'lucide-react';

export interface MaterialGroupConfig {
  order: number;
  label: string;
  color: string;    // cor para gráfico de distribuição
  icon: LucideIcon; // ícone para WasteResumoCard
  border: string;
  iconBg: string;
  iconColor: string;
}

export const MATERIAL_GROUPS: Record<string, MaterialGroupConfig> = {
  'Metais': {
    order: 0,
    label: 'Metais',
    color: 'var(--neutral-400)',
    icon: Zap,
    border: 'border-neutral-300',
    iconBg: 'bg-neutral-100',
    iconColor: 'text-neutral-600',
  },
  'Papel': {
    order: 1,
    label: 'Papel/Papelão',
    color: 'var(--primary-400)',
    icon: Newspaper,
    border: 'border-primary-300',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
  },
  'Plástico': {
    order: 2,
    label: 'Plástico',
    color: 'var(--secondary-400)',
    icon: Package,
    border: 'border-secondary-300',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-500',
  },
  'Vidro': {
    order: 3,
    label: 'Vidro',
    color: 'var(--info-400)',
    icon: GlassWater,
    border: 'border-info-300',
    iconBg: 'bg-info-100',
    iconColor: 'text-info-500',
  },
  'Reciclável': {
    order: 4,
    label: 'Reciclável',
    color: 'var(--success-400)',
    icon: Recycle,
    border: 'border-success-500/30',
    iconBg: 'bg-success-500/10',
    iconColor: 'text-success-500',
  },
};

const DEFAULT_CONFIG: MaterialGroupConfig = {
  order: 99,
  label: 'Outros',
  color: 'var(--neutral-300)',
  icon: Leaf,
  border: 'border-neutral-200',
  iconBg: 'bg-neutral-100',
  iconColor: 'text-neutral-500',
};

export function getGroupConfig(group: string): MaterialGroupConfig {
  return MATERIAL_GROUPS[group] ?? { ...DEFAULT_CONFIG, label: group };
}

export function compareGroups(a: string, b: string): number {
  return (MATERIAL_GROUPS[a]?.order ?? 99) - (MATERIAL_GROUPS[b]?.order ?? 99);
}
